(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-custom"] && !Shopify.designMode) return;
  try {
    
function updateCartCount(count) {
  document.querySelectorAll('.header__cart-count').forEach(el => {
    el.textContent = count;
  });
}

function refreshCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-logo-center');
  const burger = document.querySelector('.header__burger');
  const mobileMenu = document.querySelector('.header-mobile-menu');

  if (header) {
    refreshCartCount();
  }

  document.addEventListener('cart:updated', function () {
    refreshCartCount();
  });

  // Toggle menu mobile
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      mobileMenu.style.display = expanded ? 'none' : 'flex';
      mobileMenu.setAttribute('aria-hidden', expanded);
    });
  }

  // Scroll pour changer style — UNIQUEMENT sur l'accueil (header transparent)
  if (header && header.hasAttribute('transparent')) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // ===== Recherche inline avec suggestions live =====
  const searchForm = document.querySelector('.header-search-inline');

  if (searchForm) {
    const searchInput = searchForm.querySelector('.header-search-inline__input');
    const searchResults = searchForm.querySelector('.header-search-inline__results');

    function showResults() { searchResults.classList.add('visible'); }
    function hideResults() { searchResults.classList.remove('visible'); }

    let debounce;
    searchInput.addEventListener('input', function () {
      const q = this.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { searchResults.innerHTML = ''; hideResults(); return; }

      debounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<div class="header-search__empty">Aucun résultat pour « ' + escapeHtml(q) + ' »</div>';
              showResults();
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              const imgUrl = p.image || (p.featured_image && p.featured_image.url) || '';
              const img = imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '<img src="" alt="">';
              const price = p.price ? '<span class="header-search__result-price">' + escapeHtml(p.price) + '</span>' : '';
              return '<a class="header-search__result" href="' + p.url + '">' +
                       img +
                       '<span class="header-search__result-title">' + escapeHtml(p.title) + '</span>' +
                       price +
                     '</a>';
            }).join('');
            showResults();
          })
          .catch(function () { searchResults.innerHTML = ''; hideResults(); });
      }, 250);
    });

    // Ré-afficher au focus si déjà des résultats
    searchInput.addEventListener('focus', function () {
      if (searchResults.innerHTML.trim() !== '') showResults();
    });

    // Fermer les suggestions si clic en dehors
    document.addEventListener('click', function (e) {
      if (!searchForm.contains(e.target)) hideResults();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hideResults();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-produit-amador"] && !Shopify.designMode) return;
  try {
    
function updateCartCount(count) {
  document.querySelectorAll('.header__cart-count').forEach(el => {
    el.textContent = count;
  });
}

function refreshCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});
}

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-back');
  if (!header) return; // Section désactivée : on ne fait rien.

  refreshCartCount();

  document.addEventListener('cart:updated', function () {
    refreshCartCount();
  });

  window.addEventListener('scroll', function () {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-single-product"] && !Shopify.designMode) return;
  try {
    
function updateCartCount(count) {
  document.querySelectorAll('.header__cart-count').forEach(el => {
    el.textContent = count;
  });
}

function refreshCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});
}

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-back');
  if (!header) return; // Section désactivée : on ne fait rien.

  refreshCartCount();

  document.addEventListener('cart:updated', function () {
    refreshCartCount();
  });

  window.addEventListener('scroll', function () {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
